import { Box, Typography } from '@mui/material';
import React from 'react';
import RenderHTML from '../../../preview/RenderHTML';

export const MatchingPropLeadFieldTextShow = ({ property }) => {
  const { label, publicLabel, minValue, type } = property;

  return (
    <Box className="flex items-start justify-between gap-2">
      <Typography>{`${publicLabel || label}: `}</Typography>
      <RenderHTML HTML={minValue} />
    </Box>
  );
};
